import * as React from "react"
import { TrendingUp, TrendingDown } from "lucide-react"
import { cn } from "@/lib/utils"

interface CustomerRowProps {
  name: string
  outstanding: string
  lastPayment: string
  risk: number
  riskTrend: "up" | "down"
  isLast?: boolean
}

export function CustomerRow({ 
  name, 
  outstanding, 
  lastPayment, 
  risk, 
  riskTrend,
  isLast = false 
}: CustomerRowProps) {
  const TrendIcon = riskTrend === "up" ? TrendingUp : TrendingDown
  const trendColor = riskTrend === "up" ? "text-red-500" : "text-green-500"

  return (
    <div className={cn("flex items-center justify-between py-3", !isLast && "border-b")}>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold mb-0.5">{name}</p>
        <p className="text-xs text-muted-foreground">{lastPayment}</p>
      </div>
      <div className="text-right">
        <p className="text-sm font-bold mb-0.5">{outstanding}</p>
        <div className="flex items-center justify-end gap-1 text-xs text-muted-foreground">
          <span>Risk: {risk}%</span>
          <TrendIcon className={cn("h-3 w-3", trendColor)} />
        </div>
      </div>
    </div>
  )
}
